import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * Allows for image files to be selected and processed further, e.g, image uploads to a backend service
 */
export class PhotoUpload extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'EA';
    this.templateUrl = 'app/angularJS/components/photo_upload/photo-upload.html';
    this.scope = {
      okCallback: '=',
      image: '='
    };

    this.controller = 'PhotoUploadController';
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}